import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import { preload } from 'swr';
import { HelmetProvider } from 'react-helmet-async';
import { bloggerService } from './services/blogger';
import App from './App.tsx';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event) => {
    const isReloaded = sessionStorage.getItem('vite-preload-reloaded');
    if (!isReloaded) {
      sessionStorage.setItem('vite-preload-reloaded', 'true');
      window.location.reload();
    } else {
      console.error("Vite preload error after reload. Asset might be missing or base URL is incorrect.");
    }
  });
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    (window as any).deferredPrompt = e;
    // Dispatch a custom event so components know it's ready
    window.dispatchEvent(new Event('app-install-prompt'));
  });
  registerSW({ immediate: true });
}

// Preload critical data before React starts rendering
preload('seba_hot_news', () => bloggerService.getPostsByLabel('Seba Hot News', 6));
preload('breaking_news', () => bloggerService.getPostsByLabel('Breaking News', 5));

createRoot(document.getElementById('root')!).render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
);
